import React, { useState } from "react";

import { Layout } from "antd";
import Desktopheader from "./Desktopheader";
import DesktopSiderMenu from "../sider/DesktopSiderMenu";
import { Outlet } from "react-router";

const DesktopLayout = () => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <Layout className="min-h-screen" style={{ height: "auto" }}>
      <DesktopSiderMenu collapsed={collapsed} setCollapsed={setCollapsed} />
      <Layout>
        <Desktopheader />

        <Outlet />
      </Layout>
    </Layout>
  );
};

export default DesktopLayout;
